import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import no_noti from '../../assets/no_noti.svg';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { collection, deleteDoc, doc, getDoc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams } from 'react-router-dom';
import ModalNoti from '../../Components/ModalNoti';

function NotificationList() {
  const [data, setData] = useState([]);
  const [notiData, setNotiData] = useState([]);
  const [open, setOpen] = useState(false);
  const { userId, notiId } = useParams();
  const [isNoti, setIsNoti] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'users', userId, 'notifications'),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });

        if (list.length === 0) {
          setIsNoti(false);
        }
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, [userId]);

  useEffect(() => {
    notiId && getSingleNoti();
    // eslint-disable-next-line
  }, []);

  const getSingleNoti = async () => {
    const docRef = doc(db, 'users', userId, 'notification', notiId);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      setNotiData({ ...snapshot.data() });
    }
    console.log(notiData.isCheck);
  };

  const handleOpen = (item) => {
    setOpen(true);
    setNotiData(item);
  };

  const handleView = async (id) => {
    setOpen(false);
    setNotiData(id);
    const status = doc(db, 'users', userId, 'notifications', id);
    await updateDoc(status, {
      isCheck: true,
    });
  };

  const handleDelete = async (id) => {
    try {
      setOpen(false);
      await deleteDoc(doc(db, 'users', userId, 'notifications', id));
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <NotificationListStyled>
      {isNoti ? (
        <div className="list-container">
          <List>
            {data.map((item, index) => (
              <div className="item-container" key={index}>
                <ListItem
                  alignItems="flex-start"
                  key={item.id}
                  onClick={() => handleOpen(item)}
                  sx={{ cursor: 'pointer' }}
                >
                  <ListItemAvatar>
                    <Avatar alt={item.from} src={item.img} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={item.title}
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                          className="notification-text"
                        >
                          {item.from}
                        </Typography>
                        {' — '} {item.desc}
                      </React.Fragment>
                    }
                  />
                  {item.isCheck === true ? (
                    <p style={{ color: '#7199ff', fontSize: '14px' }}>Read</p>
                  ) : (
                    <p style={{ color: '#7199ff', fontSize: '14px' }}>Unread</p>
                  )}
                </ListItem>
                {open && (
                  <ModalNoti
                    open={open}
                    setOpen={setOpen}
                    handleDelete={handleDelete}
                    handleView={handleView}
                    {...notiData}
                  />
                )}
              </div>
            ))}
          </List>
        </div>
      ) : (
        <div className="no-noti">
          <img src={no_noti} alt="" />
          <Typography pt={4} sx={{ fontSize: '32px', color: '#999' }}>
            You don't have any new notifications
          </Typography>
        </div>
      )}
    </NotificationListStyled>
  );
}

const NotificationListStyled = styled.div`
  color: var(--accent-blue);
  padding-top: 2rem;
  .list-container {
    flex: 6;
    padding: 0 20px;
    .item-container {
      -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.4);
      box-shadow: 2px 4px 10px 1px rgba(201, 201, 201, 0.4);
      border-radius: 10px;
      .deleteButton {
        color: crimson;
        cursor: pointer;
      }
    }
  }
  .no-noti {
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
  }
`;

export default NotificationList;
